
import Vue from 'vue';
import { mapState } from 'vuex';

import ConfirmStore from './store';

const Confirm =  {
    name: 'Confirm',
    data() {
		return {};
	},
    computed: mapState({
        title: (state) => state.Confirm.title,
        show: (state) => state.Confirm.show,
        text: (state) => state.Confirm.text,
        clearText: (state) => state.Confirm.clearText,
        clearCallback: (state) => state.Confirm.clearCallback,
        confirmText: (state) => state.Confirm.confirmText,
        confirmCallback: (state) => state.Confirm.confirmCallback,
        align: (state) => state.Confirm.align,
        closeBtn: (state) => state.Confirm.closeBtn
    }),
    created() {
        if (!this.$store.state.Confirm) {
            this.$store.registerModule('Confirm', ConfirmStore);
        }
    },
    methods: {
        close() {
            this.$store.commit('Confirm/close');
        },
        clear() {
            this.$store.commit('Confirm/close');
            if(this.clearCallback) {
                this.clearCallback();
            }
        },
        confirm() {
            this.$store.commit('Confirm/close');
            if(this.confirmCallback) {
                this.confirmCallback();
            }
        }
    }
};

export default Confirm;



// WEBPACK FOOTER //
// ./src/ui/confirm/index.js